import { render, staticRenderFns } from "./PackageClaimPosted.vue?vue&type=template&id=51ccafba&"
import script from "./PackageClaimPosted.vue?vue&type=script&lang=js&"
export * from "./PackageClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./PackageClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageClaimPosted.vue"
export default component.exports